/**
 * Formats text by identifying paragraphs and highlighting key terms
 * @param {string} text - The text to format
 * @returns {Array} - Array of formatted paragraph objects
 */
export const formatScrumText = (text) => {
  if (!text) return [];
  
  // Split text into paragraphs (split by double newlines or single newlines)
  const paragraphs = text.split(/\n\n|\n/).filter(p => p.trim().length > 0);
  
  // Key Scrum terms to highlight
  const scrumTerms = [
    'Sprint', 'Product Owner', 'Scrum Master', 'Development Team',
    'Product Backlog', 'Sprint Backlog', 'Daily Scrum', 'Sprint Review',
    'Sprint Retrospective', 'Increment', 'Definition of Done', 'User Story',
    'Story Point', 'Velocity', 'Burndown Chart', 'Impediment',
    'Stakeholder', 'Agile', 'Scrum', 'Kanban', 'Backlog Refinement',
    'Planning Poker', 'Timebox', 'Epic', 'Feature', 'Task'
  ];
  
  // Create regex for matching terms (case insensitive for partial words)
  const termRegex = new RegExp(`(${scrumTerms.join('|')})`, 'gi');
  
  // Process each paragraph to highlight key terms
  return paragraphs.map(paragraph => {
    // Remove various types of quotation marks (including *) around text
    // This will remove ", ', *, and other quotation-like characters that might be used for emphasis
    let cleanedParagraph = paragraph.replace(/["'*`]/g, '');
    
    // Check if paragraph starts with a number followed by a dot (like "1. Something")
    const isListItem = /^\d+\.\s/.test(cleanedParagraph);
    
    // Check if paragraph starts with a bullet point
    const isBulletPoint = /^[-•]\s/.test(cleanedParagraph);
    
    // Check if paragraph starts with a # or ### (hashtag)
    const isHashtagStart = /^(#{1,3})\s*/.test(cleanedParagraph);
    
    // Remove the hashtag from the beginning if present
    cleanedParagraph = cleanedParagraph.replace(/^(#{1,3})\s*/, '');
    
    // Remove the bullet point from the beginning if present
    if (isBulletPoint) {
      cleanedParagraph = cleanedParagraph.replace(/^[-•]\s/, '');
    }
    
    // Remove all '-' characters from the text
    cleanedParagraph = cleanedParagraph.replace(/-/g, '');
    
    // Highlight key terms by wrapping them in strong tags
    let formattedText = cleanedParagraph.replace(termRegex, '<strong>$1</strong>');
    
    // If the paragraph started with a hashtag, highlight the entire paragraph
    if (isHashtagStart) {
      // Wrap the entire paragraph in a highlighted container
      formattedText = `<strong class="hashtag-highlight">${formattedText}</strong>`;
    }
    
    return {
      text: formattedText,
      type: isListItem ? 'list-item' : (isBulletPoint ? 'bullet-point' : (isHashtagStart ? 'hashtag' : 'paragraph'))
    };
  });
};